import React, { forwardRef } from "react";
import type {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from "react";

export type FlexboxProps = DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  row?: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
  fullFlex?: boolean;
  justify?: "start" | "center" | "end" | "between" | "around";
  align?: "start" | "center" | "end" | "stretch" | "baseline";
};

const JUSTIFY_CLASS_MAP = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
};

const ALIGN_CLASS_MAP = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline",
};

const Flexbox = forwardRef<HTMLDivElement, PropsWithChildren<FlexboxProps>>(
  (
    {
      row,
      fullWidth,
      fullHeight,
      fullFlex,
      justify = "start",
      align = "start",
      className,
      children,
      ...divProps
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={`flex ${row ? "flex-row" : "flex-col"} ${
          fullWidth ? "w-full" : ""
        } ${fullHeight ? "h-full" : ""} ${fullFlex ? "flex-1" : ""} ${
          JUSTIFY_CLASS_MAP[justify]
        } ${ALIGN_CLASS_MAP[align]} ${className ?? ""}`}
        {...divProps}
      >
        {children}
      </div>
    );
  },
);

Flexbox.displayName = "Flexbox";

export default Flexbox;
